module.exports = __webpack_public_path__ + "img/office_door.addb2407.jpg";